






























import Vue, { PropType } from 'vue';
import { getEmailStatusConfig } from '@/helpers/stats-utils';
import EmailPreviewTooltip from '@/components/Reactivation/EmailPreviewTooltip.vue';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import CampaignTableRow from './CampaignTableRow.vue';

export default Vue.extend({
  name: 'CampaignTable',
  components: {
    EmailPreviewTooltip,
    CampaignTableRow,
  },
  mixins: [CopyToClipboard],
  props: {
    campaigns: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data() {
    return {
      getEmailStatusConfig,
    };
  },
});
